import { Box, Toolbar, useTheme, useMediaQuery, Paper } from "@mui/material";
import React, { useState, useEffect } from "react";
import Header from "layouts/Header";
import Drawer from "layouts/Drawer";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openDrawer } from "store/reducers/menu";
import Navigation from "layouts/Navigation";
import SimpleBar from "components/SimpleBar";

function MainLayout() {
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);
  const [open, setOpen] = useState(drawerOpen);
  const toggleMenu = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down("lg"));
  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
  }, [drawerOpen, open]);
  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));
  }, [dispatch, matchDownLG]);
  return (
    <Box sx={{ display: "flex" }}>
      <Drawer open={open} toggleMenu={toggleMenu} />
      <Header open={open} toggleMenu={toggleMenu} />
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          flexGrow: 1,
          paddingX: { xs: 2, sm: 3 },
          paddingTop: { xs: 2, sm: 3 },
          paddingBottom: { xs: 0, sm: 0 },
          backgroundColor: theme.palette.background.default,
          overflow: "hidden",
        }}
      >
        <Toolbar />
        <Navigation />
        <Paper
          sx={{
            display: "flex",
            flexGrow: 1,
            p: { xs: 0, sm: 0 },
            overflow: "hidden",
          }}
        >
          <SimpleBar
            style={{
              maxHeight: "100%",
              display: "flex",
              flexGrow: 1,
            }}
          >
            <Outlet />
          </SimpleBar>
        </Paper>
      </Box>
    </Box>
  );
}

export default MainLayout;
